import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('./home/home-routes').then(r => r.routes),
        title: 'Home',
    },
    {
        path: 'pages/privacy',
        redirectTo: '/privacy-policy',
        pathMatch: 'full',
    },
    {
        path: 'privacy-policy',
        title: 'Privacy Policy',
        loadComponent: () => import('./pages/privacy/privacy.component').then(m => m.PrivacyComponent),
    },
    {
        path: 'profile/:id',
        loadChildren: () => import('./profile/profile-routes').then(r => r.routes),
        title: 'Profile',
    },
    {
        path: 'team/:id',
        loadChildren: () => import('./team/teams-routes').then(r => r.routes),
        title: 'Team',
    },
    {
        path: 'tournament/:id',
        loadChildren: () => import('./tournament/tournament-routes').then(r => r.routes),
        title: 'Tournament',
    },
    {
        path: 'tournamentv2/:id',
        loadChildren: () => import('./tournament/tournament-routes').then(r => r.routes),
        title: 'Tournament',
    },
    {
        path: 'notification-center',
        loadChildren: () => import('./notification-center/notification-center-routes').then(r => r.routes),
        title: 'Notifications',
    },
    {
        path: 'all-tournaments',
        loadChildren: () => import('./all-tournaments/all-tournaments-routes').then(r => r.routes),
        title: 'All Tournaments',
    },
    {
        path: 'games',
        loadChildren: () => import('./games/games-routes').then(r => r.routes),
        title: 'Games',
    },
    {
        path: 'rewards',
        loadChildren: () => import('./reward/reward-routes').then(r => r.routes),
        title: 'Rewards',
    },
    /*
    TODO: Re-enable shop routes once the shop is ready. For now, keeping it disabled to avoid confusion as the shop is not fully functional yet.
    {
        path: 'shop',
        loadChildren: () => import('./shop/shop-routes').then(r => r.routes),
        title: 'Shop',
    },
    */
    {
        path: 'season',
        loadComponent: () => import('./season/season.component').then(m => m.SeasonComponent),
        children: [
            {
                path: 'details/:id',
                loadComponent: () => import('./season/season-details/season-details.component').then(m => m.SeasonDetailsComponent),
            }
        ],
        title: 'Season',
    },
    {
        path: 'leaderboard',
        loadChildren: () => import('./leaderboard/leaderboard-routes').then(r => r.routes),
        title: 'Leaderboard',
    },
    {
        path: 'wallet',
        loadChildren: () => import('./wallet/wallet-routes').then(r => r.routes),
        title: 'Wallet',
    },
    {
        path: 'pages',
        loadChildren: () => import('./pages/pages-routes').then(r => r.routes),
        title: 'Pages',
    },
    {
        path: 'integrations/:name',
        loadComponent: () => import('./integrations/integrations.component').then(m => m.IntegrationsComponent),
    },
    {
        path: 'about',
        loadComponent: () => import('./about-static/about-static.component').then(m => m.AboutStaticComponent),
    },
    {
        path: 'contact-us',
        loadComponent: () => import('./contact-us/contact-us.component').then(m => m.ContactUsComponent),
    },
    {
        path: 'login',
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    },
    {
        path: 'redirect-to',
        loadComponent: () => import('./redirect-to/redirect-to-component').then(m => m.RedirectToComponent),
    },
    {
        path: '**',
        loadComponent: () => import('./errors/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            paramsInheritanceStrategy: 'always',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
